import { Suspense } from 'react';

import { ReactComponent as Loader } from 'assets/vectors/logo-animated-lines.svg';

import { eersteTestvlucht } from 'mocks/exercises/1848_232904';
import { CodiIntroDialog } from '../partials/CodiIntroDialog';
import Exercise from './Exercise';

export function ExerciseContainer() {
  const exercise = eersteTestvlucht;
  const isFetching = false;
  const refetch = () => {};

  return (
    <Suspense
      fallback={
        <div className="flex flex-col items-center justify-center w-full h-full">
          <Loader className="w-32" />
        </div>
      }
    >
      <Exercise
        exercise={exercise}
        isRestarting={isFetching}
        restart={() => {
          refetch();
        }}
      />
      <CodiIntroDialog hasCodi={Boolean(exercise?.versionTestPlanId)} />
    </Suspense>
  );
}
